// @flow
export const SETTINGS_MODULE_NAME: 'settings' = 'settings';

export const SETTINGS_ACTION_TYPE: {
    SET_COMPANY_DATA: 'SET_COMPANY_DATA',
    SET_LAST_SERVER_UPDATE: 'SET_LAST_SERVER_UPDATE',
} = {
    SET_COMPANY_DATA: 'SET_COMPANY_DATA',
    SET_LAST_SERVER_UPDATE: 'SET_LAST_SERVER_UPDATE',
};
